import { z } from 'zod'
import { ContainerWidth } from '../constants'

export const SettingsSchema = z.object({
  maxWidth: z.number().min(ContainerWidth.Min).max(ContainerWidth.Max),
  backgroundColor: z.string().nullable(),
  contentBackgroundColor: z.string().nullable(),
  linkColor: z.string(),
  textFontSize: z.number().positive(),
  textColor: z.string(),
})

export type SettingsType = z.infer<typeof SettingsSchema>
